<a [routerLink]="['/messages']" class="cursor-pointer md:hidden block relative -top-1">
  <span *ngIf="notSeenRoomCounts > 0" class="rounded-full text-center inline-block absolute  -top-1 left-3 text-sm w-[25px] h-[25px] leading-[25px]  bg-primary">{{(notSeenRoomCounts>9)?'9+':notSeenRoomCounts}}</span>
  <svg width="31" height="31" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M10.0913 20.8632L9.70203 20.7499L9.39406 21.0136C7.80415 22.3748 6.03388 23.0621 4.6486 23.4077C4.51029 23.4422 4.37608 23.4733 4.24656 23.5012C5.86505 21.4933 6.22749 20.0532 6.28924 19.3123L6.32145 18.9257L6.02462 18.6761C4.17869 17.1233 3.0835 15.0583 3.0835 12.8333C3.0835 8.23945 7.83157 4.25 14.0002 4.25C20.1688 4.25 24.9168 8.23945 24.9168 12.8333C24.9168 17.4272 20.1688 21.4167 14.0002 21.4167C12.6259 21.4167 11.3081 21.2172 10.0913 20.8632Z" stroke="currentColor" stroke-width="1.5"/>
  </svg>
</a>
<div class="md:block hidden">
  <app-dropdown [ignoreInnerClick]="true">
    <div class="dropdown-button">
      <button (click)="onOpen()" [className]="notSeenRoomCounts > 0?'messages has-unreaded':'messages'">
        <span *ngIf="notSeenRoomCounts > 0" class="rounded-full inline-block absolute  -top-1 text-sm w-[25px] h-[25px] leading-[25px]  bg-primary">{{(notSeenRoomCounts>9)?'9+':notSeenRoomCounts}}</span>
        <svg width="31" height="31" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M10.0913 20.8632L9.70203 20.7499L9.39406 21.0136C7.80415 22.3748 6.03388 23.0621 4.6486 23.4077C4.51029 23.4422 4.37608 23.4733 4.24656 23.5012C5.86505 21.4933 6.22749 20.0532 6.28924 19.3123L6.32145 18.9257L6.02462 18.6761C4.17869 17.1233 3.0835 15.0583 3.0835 12.8333C3.0835 8.23945 7.83157 4.25 14.0002 4.25C20.1688 4.25 24.9168 8.23945 24.9168 12.8333C24.9168 17.4272 20.1688 21.4167 14.0002 21.4167C12.6259 21.4167 11.3081 21.2172 10.0913 20.8632Z" stroke="currentColor" stroke-width="1.5"/>
        </svg>
      </button>

    </div>
    <div class="dropdown-options">
      <div class="absolute -left-[400px] top-full z-10 mt-3 w-screen max-w-md overflow-hidden rounded-lg bg-card shadow-lg ring-1 ring-button-primary-outline">
        <div class="tab-section">
          @defer (on viewport){
              @if(!onlyOne){
                  <app-tabs [activeTab]="chatTabs[0].key" [tabs]="chatTabs" (handleClick)="showTab($event)">
                      <div class="scroll-block tab-content">
                          <div class="scroll-block tab-content px-2">
                              <app-custom-search-input
                                      class="bg-transparent text-normal w-100"
                                      labelClass="green"
                                      labelText="{{'search' | translate}}"
                                      (changeInput) = "getRooms($event)"
                                      (changeOnkeyup) = "getRooms($event)"
                              ></app-custom-search-input>
                              <div class="w-full border-t border-button-primary-outline"></div>

                              <!--                    <app-dropdown  [options]='options' (callback)='res($event)' [dropDawnstatus]='openInviteDropDawnOptions' [updateVariable] = 'updateVariable'></app-dropdown>-->

                          </div>
                          <app-scrollable-wall
                                  (load)="loadMore()"
                                  height="60vh"
                                  scrollHeight="99%"
                          >
                              <div class="users-list">

                                  <div class="list-item" *ngFor="let room of rooms">
                                      <app-chat-room-item
                                              [room]="room"
                                              (openChat) = "openChatWidget($event)"
                                              (deleteRoom) = "deleteRoom($event)"
                                              (editRoom)= "editRoom($event)"
                                              [showOptions] = "true"
                                              [updateVariable] = "room.updateVariable"
                                      >
                                      </app-chat-room-item>

                                      <div class="w-full border-t border-button-secondary-outline"></div>
                                  </div>
                                  <app-skeleton-message *ngIf="loading">
                                  </app-skeleton-message>

                              </div>
                          </app-scrollable-wall>
                      </div>
                  </app-tabs>
              } @else {
                  <div class="scroll-block tab-content">
                      <div class="scroll-block tab-content px-2">
                          <app-custom-search-input
                                  class="bg-transparent white w-100"
                                  labelClass="green"
                                  labelText="{{'search' | translate}}"
                                  (changeInput) = "getRooms($event)"
                                  (changeOnkeyup) = "getRooms($event)"
                          ></app-custom-search-input>
                          <div class="w-full border-t border-gray-600"></div>

                          <!--                    <app-dropdown  [options]='options' (callback)='res($event)' [dropDawnstatus]='openInviteDropDawnOptions' [updateVariable] = 'updateVariable'></app-dropdown>-->

                      </div>
                      <app-scrollable-wall
                              (load)="loadMore()"
                              height="60vh"
                              scrollHeight="99%"
                      >
                          <div class="users-list">

                              <div class="list-item" *ngFor="let room of rooms">
                                  <app-chat-room-item
                                          [room]="room"
                                          (openChat) = "openChatWidget($event)"
                                          (deleteRoom) = "deleteRoom($event)"
                                          (editRoom)= "editRoom($event)"
                                          [showOptions] = "true"
                                          [updateVariable] = "room.updateVariable"
                                  >
                                  </app-chat-room-item>

                                  <div class="w-full border-t border-gray-800"></div>
                              </div>
                              <app-skeleton-message *ngIf="loading">
                              </app-skeleton-message>

                          </div>
                      </app-scrollable-wall>
                  </div>
              }

          } @placeholder{
            <app-skeleton-loader></app-skeleton-loader>
          }
        </div>
<!--        <div class="grid grid-cols-2 divide-x divide-gray-900/5 bg-card">-->
<!--          <a  (click)="viewAll()"   class="flex items-center justify-center text-normal gap-x-2.5 p-3 text-sm font-semibold leading-6 hover:bg-card-hover">-->
<!--            {{'view_all'| translate}}-->
<!--          </a>-->
<!--          <a (click)="markAllAsRead()"  class="flex items-center justify-center text-normal gap-x-2.5 p-3 text-sm font-semibold leading-6 hover:bg-card-hover">-->
<!--            {{'mark_all_as_read'| translate}}-->
<!--          </a>-->
<!--        </div>-->
      </div>
    </div>
  </app-dropdown>

</div>
